import { memo } from 'react';
import { IconProps } from './iconType';

export const ArrowPrevIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M11.1659 2.33288C11.2531 2.42217 11.3019 2.54205 11.3019 2.66688C11.3019 2.79171 11.2531 2.91159 11.1659 3.00088L6.29288 7.99988L11.1659 12.9979C11.2531 13.0872 11.3019 13.207 11.3019 13.3319C11.3019 13.4567 11.2531 13.5766 11.1659 13.6659C11.1235 13.7094 11.0728 13.744 11.0168 13.7677C10.9608 13.7913 10.9006 13.8035 10.8399 13.8035C10.7791 13.8035 10.7189 13.7913 10.663 13.7677C10.607 13.744 10.5563 13.7094 10.5139 13.6659L5.33188 8.34888C5.24086 8.25551 5.18992 8.13027 5.18992 7.99988C5.18992 7.86949 5.24086 7.74425 5.33188 7.65088L10.5139 2.33388C10.5563 2.29034 10.607 2.25573 10.663 2.2321C10.7189 2.20846 10.7791 2.19629 10.8399 2.19629C10.9006 2.19629 10.9608 2.20846 11.0168 2.2321C11.0728 2.25573 11.1235 2.29034 11.1659 2.33388V2.33288Z"
        fill={color}
      />
    </svg>
  );
});

ArrowPrevIcon.displayName = 'ArrowPrevIcon';
